import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {EditProductComponent} from "./edit-product.component";
import {ManageProductsComponent} from "./manage-products.component";
import {ManageTypesComponent} from "./manage-types.component";
import {ManageMenusComponent} from "./manage-menus.component";
import {ClientProductsComponent} from "./client-products.component";
import {ManageOrdersComponent} from "./manage-orders.component";
import {AdminLoginComponent} from "./admin-login.component";
import {AuthGuard} from "./guards/auth.guard";

const routes: Routes = [
    /*{ path: '', redirectTo: '/client-list', pathMatch: 'full' },*/
    { path: 'app-client-list-products',  component: ClientProductsComponent },
    { path: 'admin-login', component: AdminLoginComponent },
    { path: 'admin-edit-product/:id', component: EditProductComponent, canActivate: [AuthGuard] },
    { path: 'admin-manage-products', component: ManageProductsComponent, canActivate: [AuthGuard]},
    { path: 'admin-manage-orders', component: ManageOrdersComponent, canActivate: [AuthGuard]},
    { path: 'admin-manage-types', component: ManageTypesComponent, canActivate: [AuthGuard]},
    { path: 'admin-manage-menus', component: ManageMenusComponent, canActivate: [AuthGuard]}
];

@NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ]
})
export class AppRoutingModule {}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/app-routing.module.ts